export default "__VITE_ASSET__DoCUYxKj__"